'use strict';

import { set } from "vue-analytics";

/**
 * scrSection
 */
export const scrSection = (() => {
    let current;
    /**
     * init
     */
    const init = () => {
        // if (location.href.indexOf('question') === -1 && location.href.indexOf('result') === -1) {

        //     $(function () {
        //         $.scrollify({
        //             section: ".js-scrSec",
        //             setHeights: false,
        //             updateHash: false,
        //             easing: "easeOutExpo",
        //             scrollSpeed: 600,
        //             before: function (i, box) {
        //                 current = i;
        //             },
        //         });
        //     });

        //     $(window).on('resize', function () {
        //         if ($('.is-scrActive').length) {
        //             if (current) {
        //                 var currentScrl = $('.js-scrSec').eq(current).offset().top;
        //                 $(window).scrollTop(currentScrl);
        //             }
        //         }
        //     });

        //     $(window).on('scroll load', function () {

        //         if ($.scrollify.current().hasClass('js-inview')) {
        //             $.scrollify.current().addClass('is-inview');
        //         }

        //         if ($.scrollify.current().hasClass('js-lastSec')) {
        //             $('.js-scrBtn').addClass('is-hide');
        //             $('.js-stBtn').removeClass('is-hide');
        //         }
        //         else {
        //             $('.js-scrBtn').removeClass('is-hide');
        //             $('.js-stBtn').addClass('is-hide');
        //         }
        //     });

        //     $(window).on('load', function () {
        //         $.scrollify.move(0);
        //     });
        // }
        // else {
        //     $.scrollify.destroy();
        // }

        justHeight();
        setTimeout(() => {
            justHeight();
        }, 300);
        $(window).on('load resize', function () {
            justHeight();
        });

    };

    const justHeight = () => {
        let winH = $(window).height();
        let btnH = $('.js-scrBtn').height();
        let secH = winH - btnH;
        let parentH = secH * 5 + btnH;
        $('.js-scrSec').outerHeight(secH);
        $('.js-scrSec-parent').outerHeight(parentH);
    }


    return {
        init: init
    };
})();